import { registerSectionType } from "../../utils/sectionRegistry";
import { Section, renderRichTextContent } from "../sectionHelpers";

registerSectionType({
  type: "texto",
  label: "Texto",
  layout: "simple",
  previewBlocks: ["Parrafo", "Parrafo", "Parrafo"],
  getDefaults: () => ({ type: "texto", title: "", description: "", paragraphs: [""] }),
  render: (section, index) => {
    const paragraphs = Array.isArray(section?.paragraphs) ? section.paragraphs : [];
    return (
      <Section section={section} className="dynamic-section-texto" keyName={`rich-${index}`}>
        <div className="dynamic-rich-text dynamic-rich-text-enhanced">{renderRichTextContent(paragraphs)}</div>
      </Section>
    );
  },
});
